// ============================================================================
// MODULAR DESIGN PRINCIPLES (MANDATORY)
// ============================================================================
// This file strictly follows:
// 1. Single Responsibility Principle - Format API errors for display
// 2. Separation of Concerns - Presentation string from axios shape
// 3. Modular Architecture - Reusable across components
//
// Refer to: docs/architecture/modular-design-standards.md
// ============================================================================

/**
 * Human-readable message from an axios/FastAPI error response.
 * FastAPI validation uses detail: Array<{ loc, msg, type }>.
 */
export function getApiErrorMessage(err, fallback = 'Request failed') {
  if (err?.code === 'ECONNABORTED') {
    const ms = err?.config?.timeout;
    return `Request timed out${ms ? ` after ${ms / 1000}s` : ''}. Increase VITE_API_TIMEOUT or the endpoint-specific timeout in front-end .env and restart the dev server.`;
  }
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail
      .map((x) => (typeof x === 'string' ? x : x?.msg || JSON.stringify(x)))
      .filter(Boolean)
      .join('; ');
  }
  if (typeof detail === 'string') {
    return detail;
  }
  if (detail && typeof detail === 'object' && typeof detail.message === 'string') {
    return detail.message;
  }
  if (err?.message) {
    return err.message;
  }
  return fallback;
}
